/* Модальное окно об отсутствии программ для Главной страницы */
function modalMissProgMain(Regions, arr, arrAllProgramsDirections, arrAllProgramsRegions) {
  let elementEmptyModal = document.querySelector('.form__field-regions'), 
    emptyModal = '';

  if (arrAllProgramsRegions.length == 0) {
    emptyModal = `<div class="form__field-regions"><div class="form__field-regions__block"><p>К сожалению, по данному региону нет доступных программ</p></div></div>` 
  } else if (arrAllProgramsDirections.length == 0) {
    emptyModal = `<div class="form__field-regions"><div class="form__field-regions__block"><p>К сожалению, по данному направлению нет доступных программ</p></div></div>`;
  } else {
    emptyModal = `<div class="form__field-regions"><div class="form__field-regions__block"><p>К сожалению, по данному уровню образования нет доступных программ</p></div></div>`;
  }   

  elementEmptyModal?.remove();

  if (Regions.value == '') {
    return;
  }
  
  if (arr === undefined || arr.length == 0) {
    Regions.insertAdjacentHTML('afterend', emptyModal);
  } else {
    elementEmptyModal?.remove();
  }
}

export default modalMissProgMain;
